module.exports = __webpack_public_path__ + "img/session4_bg_m.b2efca80.jpg";